import { qs } from "@fluorescent/dom";

export default function PredictiveSearch(resultsContainer) {
  const settings = qs("[data-search-settings]", document);
  const { limit, show_articles, show_pages } = JSON.parse(settings.innerHTML);
  const cachedResults = {};

  // Broken down highlightable elements
  const headingOpeningElement = `<div class="quick-search__result-heading">`;
  const headingClosingElement = `</div>`;
  const vendorsOpeningElement = '<span class="quick-search__result-vendor">';
  const vendorsClosingElement = "</span>";

  // Build out type query string
  let types = "product";

  if (show_articles) {
    types += ",article";
  }

  if (show_pages) {
    types += ",page";
  }

  function renderSearchResults(resultsMarkup) {
    resultsContainer.innerHTML = resultsMarkup;
  }

  function highlightQuery(searchTerm, searchResult) {
    const regexHeadings = new RegExp(
      `${headingOpeningElement}(.*?)${headingClosingElement}`,
      "g"
    );
    const regexVendors = new RegExp(
      `${vendorsOpeningElement}(.*?)${vendorsClosingElement}`,
      "g"
    );
    let highlightedResult = searchResult;

    // Highlight all instances of the search term in headings
    highlightedResult = highlightedResult.replaceAll(regexHeadings, match => {
      return highlightInner(searchTerm, match, {
        openingElement: headingOpeningElement,
        closingElement: headingClosingElement,
      });
    });

    // Highlight all instances of the search term in vendor -- specific to product results
    highlightedResult = highlightedResult.replaceAll(regexVendors, match => {
      return highlightInner(searchTerm, match, {
        openingElement: vendorsOpeningElement,
        closingElement: vendorsClosingElement,
      });
    });

    return highlightedResult;
  }

  function highlightInner(searchTerm, matchedString, elements) {
    const regex = new RegExp(`(${searchTerm})`, "gi");
    let highlightedSearch = matchedString;

    // Remove opening element
    highlightedSearch = highlightedSearch.replace(elements.openingElement, "");

    // Remove closing element
    highlightedSearch = highlightedSearch.replace(elements.closingElement, "");

    // Return all elements in proper order after adding highlight spans
    return (
      elements.openingElement +
      highlightedSearch.replace(regex, '<mark class="hl">$1</mark>') +
      elements.closingElement
    );
  }

  function getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    // Render result if it appears within the cache
    if (cachedResults[`${queryKey}`]) {
      renderSearchResults(cachedResults[`${queryKey}`]);
      return;
    }

    fetch(
      `${window.theme.routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&${encodeURIComponent("resources[type]")}=${types}&${encodeURIComponent(
        "resources[limit]"
      )}=${limit}&section_id=predictive-search&resources[options][fields]=title,product_type,variants.title,body,vendor`
    )
      .then(response => {
        if (!response.ok) {
          const error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then(text => {
        let resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        // Highlight query
        resultsMarkup = highlightQuery(searchTerm, resultsMarkup);

        // Cache results
        cachedResults[queryKey] = resultsMarkup;
        renderSearchResults(resultsMarkup);
      })
      .catch(error => {
        throw error;
      });
  }

  return { getSearchResults };
}
